import { Controller } from "react-hook-form";
import type { Control, FieldValues } from "react-hook-form";
import {
  AsyncSearchableSelect,
  type AsyncSelectOption,
} from "@/components/Form/AsyncSearchableSelect/AsyncSearchableSelect";
import styles from "../../CmsCreateBpaPage.module.css";
import shared from "../cmsShared.module.css";

type BpaAssignmentFieldsProps<T extends FieldValues = FieldValues> = {
  control: Control<T>;
  searchResearchers: (query: string) => Promise<AsyncSelectOption[]>;
  initialResearcherOption?: AsyncSelectOption | null;
  initialEditorOption?: AsyncSelectOption | null;
  editionName?: string;
  plain?: boolean;
};

export function BpaAssignmentFields<T extends FieldValues = FieldValues>({
  control,
  searchResearchers,
  initialResearcherOption,
  initialEditorOption,
  editionName,
  plain = false,
}: BpaAssignmentFieldsProps<T>) {
  const fields = (
    <div className={styles.fieldRow}>
      <div className={styles.field}>
        <Controller
          name={"assignedResearcherId" as never}
          control={control}
          render={({ field }) => (
            <AsyncSearchableSelect
              name="assignedResearcherId"
              label="Assigned researcher"
              value={field.value as string | null}
              onChange={val => field.onChange(val ?? null)}
              onSearch={searchResearchers}
              placeholder="Search..."
              minSearchLength={0}
              initialOption={initialResearcherOption}
            />
          )}
        />
      </div>
      <div className={styles.field}>
        <Controller
          name={"assignedEditorId" as never}
          control={control}
          render={({ field }) => (
            <AsyncSearchableSelect
              name="assignedEditorId"
              label="Assigned editor"
              value={field.value as string | null}
              onChange={val => field.onChange(val ?? null)}
              onSearch={searchResearchers}
              placeholder="Search..."
              minSearchLength={0}
              initialOption={initialEditorOption}
            />
          )}
        />
      </div>
    </div>
  );

  if (plain) return fields;

  return (
    <section className={shared.sectionCard}>
      <h2 className={shared.sectionHeading}>{editionName ? `Edition assignment` : "Assignment"}</h2>
      {editionName && (
        <p className={styles.sectionNote}>These fields apply only to the {editionName} edition.</p>
      )}
      {fields}
    </section>
  );
}
